<template>
  <v-btn
    v-bind="$attrs"
    @click="$emit('input', !value)"
    :color="value ? 'primary' : ''"
  >
    {{ label }}
    <v-icon small v-if="value">mdi-check-box-outline</v-icon>
    <v-icon small v-else>mdi-checkbox-blank-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'CheckableButton',
  props: {
    label: { type: String, required: false },
    value: { type: Boolean, required: false, default: false },
  },
};
</script>
